/*
 * En que entorno esta corriendo esto.
 *
 * El panel escribe en la rama del sitio desde el que se abrio: en
 * dev.emidia.cl guarda en `dev`, y en emidia.cl guarda en `production`. Asi
 * no hay que cambiar configuracion al mergear, y lo que Valentina suba al
 * sitio de prueba viaja a produccion con el propio merge.
 */

const HOSTS_PRODUCCION = ['emidia.cl', 'www.emidia.cl'];

export const esProduccion = () => HOSTS_PRODUCCION.includes(window.location.hostname);

export const rama = () => (esProduccion() ? 'production' : 'dev');

export const sitio = () =>
  esProduccion() ? 'https://www.emidia.cl' : window.location.origin;
